var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.box,on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{class:_vm.$style.content},[_c('img',{attrs:{"src":`${_vm.$cdnUrl}/dragonCity/sign_bg.png`}}),_c('img',{attrs:{"src":`${_vm.$cdnUrl}/dragonCity/close.png`},on:{"click":_vm.close}}),_c('div',{class:_vm.$style.enter,on:{"click":_vm.jump}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }